import React, { useState, useEffect, useRef } from 'react'
import "./Login.css"
import { CircularProgress, IconButton, InputAdornment, OutlinedInput, Typography } from '@mui/material'
import SignupLoginImage from '../../component/signup-image/SignupLoginImage'
import { Navigate, useNavigate } from 'react-router-dom';
import MyContext from '../../Context/AppContext';
import LoginUser from '../../Apis/LoginUser';
import 'react-toastify/dist/ReactToastify.css';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { showToast } from '../../utils/toastUtils';
import SupportEmail from '../../component/SupportEmail/SupportEmail';
import NLBLOGO from '../../assets/images/nlblogo.png'
import LoaderPage from '../../component/loaderPage/LoaderPage';

const Login = () => {
    const navigate = useNavigate();
    const initialRun = useRef(false);
    const { checkAuthStatus, checkLimitExceed, setContactUsModalOpen, setIsBackdropEnabled, setUserDetails,userDetails } = React.useContext(MyContext);
    const [showPassword, setShowPassword] = useState(false);
    const [disableButton, setDisableButton] = useState(false)
    const [userDetails_login, setUserDetails_login] = useState({
        email: '',
        password: ''
    })
    const [isAuthenticated, setIsAuthenticated] = useState(null)
    const [limitExceed, setLimitExceed] = useState(false)


    const handleSignUp = () => {
        navigate('/sign-up')
    }

    const goToResetPassword = () => {
        navigate("/reset-password")
    }

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    }


    const login = async () => {
        try {
            if (userDetails_login.email === '' || userDetails_login.password === '') {
                showToast('Please fill all the fields', 'error')
                return;
            }
            setDisableButton(true)
            const response = await LoginUser(userDetails_login);

            if (response.status === 200) {
                if (response?.data?.userData?.accountStatus?.isPending === true && response?.data?.userData?.accountStatus?.isRejected === true) {
                    setDisableButton(false)
                    showToast("Your account has been deactivated. Contact support if you require further assistance", "error")
                    localStorage.clear();
                    navigate('/')
                }
                else {
                    window.localStorage.setItem('token', response?.data?.userData?.token)
                    window.localStorage.setItem('userId', response?.data?.userData?._id)
                    setUserDetails(response?.data?.userData)
                    let limitExceedStatus = checkLimitExceed()
                    if (limitExceedStatus || response?.data?.userData?.accountConfig?.permissions?.createJd === false) {
                        navigate('/app/limitExceeded')
                    }
                    else {
                        navigate('/app/chat')
                    }
                }


            } else {
                let errMessage = response?.response?.data?.detail || 'User Login Failed'
                setDisableButton(false)
                showToast(errMessage, 'error')
            }
        } catch (error) {
            setDisableButton(false)
            showToast('User Login Failed', 'error')
            console.log('error', error)
        }

    }
    const checkAuthenticationStatus = async () => {
        setIsAuthenticated(null)
        let response = await checkAuthStatus()
        if (response) {
            let limitExceedStatus = checkLimitExceed()
            setLimitExceed(limitExceedStatus)
        }
        setIsAuthenticated(response)
    }

    useEffect(() => {
        if (!initialRun.current) {
            checkAuthenticationStatus();
            initialRun.current = true;
        }
    }, [])

    
    return (
        isAuthenticated === null ? <LoaderPage /> : isAuthenticated === true ? limitExceed || userDetails?.accountConfig?.permissions?.createJd === false
        ? <Navigate to='/app/limitExceeded' /> : <Navigate to='/app/chat' /> :
            <div className='signup-page'>
                <SignupLoginImage />
                <div className='signup-Div'>
                    <div className='login-card'>
                        <Typography component="h5" variant="h5">Noah.ai</Typography>
                        <img src={NLBLOGO} alt='NLB Services' className='logo_brand' />
                        <Typography component="p" variant="p">Log In</Typography>

                        <div className='inputFieldsContainer'>
                            <span>Email*</span>
                            <OutlinedInput
                                placeholder='Enter your email...'
                                value={userDetails_login.email}
                                onChange={(e) => setUserDetails_login({ ...userDetails_login, email: e.target.value })}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        login();
                                    }
                                }}
                            />
                        </div>

                        <div className='inputFieldsContainer'>
                            <span>Password*</span>
                            <OutlinedInput
                                placeholder='Enter your password...'
                                className='passwordInput'
                                type={showPassword ? 'text' : 'password'}
                                value={userDetails_login.password}
                                onChange={(e) => setUserDetails_login({ ...userDetails_login, password: e.target.value })}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        login();
                                    }
                                }}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label={showPassword ? 'hide the password' : 'display the password'}
                                            onClick={handleClickShowPassword}
                                            edge="end"
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </div>
                        <div className='forget_loginpage' onClick={() => disableButton ? null : goToResetPassword()}>Forgot Password?</div>

                        <button
                            className={disableButton ? 'loginButton loginButtonDisabled' : 'loginButton'}
                            type='submit'
                            onClick={(e) => login()}
                            disabled={disableButton}
                        >
                            <span>{disableButton ? "Please wait..." : "Log In"}</span>
                            {disableButton && <CircularProgress className='cp_loginButton' />}
                        </button>

                        <div className='loginNoAccountMessageContainer'>
                            <span className='loginNoAccountMessage'>Don't have any account yet? </span>
                            <span onClick={(e) => disableButton ? null : handleSignUp()} className='signup_login'>Free Sign Up</span>
                        </div>
                        <button className='contactUsButton_login' onClick={() => setContactUsModalOpen(true)}>
                            <span>Contact Us</span>
                        </button>

                    </div>
                </div>
                <SupportEmail />
                {/* <BackDropLoader /> */}
            </div>

    )
}

export default Login
